const blueIconCheckbox = `
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="17" height="17" rx="2" fill="#3B99FC"/>
      <path d="M5 8.47617L7.69864 11L12.9832 5" stroke="white" stroke-width="2" stroke-linecap="round"/>
    </svg>
`;

export default blueIconCheckbox;
